<template>
  <div>
    <div class="head">
      <div class="head-title">
        {{title}}
      </div>
      <div class="sub-title">
        <span>{{subTitle}}</span>
        <span class="caption">{{ company }}</span>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubItem',
  props: {
    title: String,
    subTitle: String,
    company: String
  }
}
</script>

<style scoped lang="less">
@import "../common";

.head {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: @padding;

  .head-title {
    font-weight: bold;
  }

  .sub-title {
    span:first-child {
      font-weight: bold;
    }

    span:last-child {
      padding-left: @padding;
      font-weight: bold;
    }
  }
}
</style>
